import { render, staticRenderFns } from "./leftTab.vue?vue&type=template&id=91f2be68&scoped=true&"
import script from "./leftTab.vue?vue&type=script&lang=ts&"
export * from "./leftTab.vue?vue&type=script&lang=ts&"
import style0 from "./leftTab.vue?vue&type=style&index=0&id=91f2be68&lang=scss&scoped=true&"
import style1 from "./leftTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f2be68",
  null
  
)

export default component.exports